import React, { useContext } from 'react'
import { ThemeContext } from 'f-web-app'

export default function FinishOrderButtonView() {
  const { Components } = useContext(ThemeContext)
  return <Components.PaintedButtonView label="Finish" />
}
